import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "onChange", "defaultValue", "min", "max"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { useEventCallback, useIsomorphicLayoutEffect } from '@cian/react-utils';
import { IMaskInput } from '../../../../internal/components/IMaskInput';
import { useControlled } from '../../../../internal/hooks';
import { invoke } from '../../../../internal/utils';
import { format } from '../../../../internal/utils/date';
import { IMASK_DATE_INPUT_OPTIONS } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
export var NativeDateMaskInput = /*#__PURE__*/React.forwardRef(function NativeDateMaskInput(props, ref) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var as = props.as,
    onChange = props.onChange,
    defaultValue = props.defaultValue,
    min = props.min,
    max = props.max,
    rest = _objectWithoutProperties(props, _excluded);
  var _useControlled = useControlled({
      controlled: props.value,
      default: defaultValue !== undefined ? defaultValue : undefined
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    value = _useControlled2[0],
    setValue = _useControlled2[1];
  var fotmattedValue = toStringValue(value);
  var inputValueRef = React.useRef(fotmattedValue);
  var _React$useState = React.useState(fotmattedValue),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    inputValue = _React$useState2[0],
    _setInputValue = _React$useState2[1];
  var setInputValue = useEventCallback(function (nextValue) {
    inputValueRef.current = nextValue;
    _setInputValue(nextValue);
  });
  useIsomorphicLayoutEffect(function () {
    var nextInputValue = toStringValue(value);
    if (inputValueRef.current !== nextInputValue) {
      setInputValue(nextInputValue);
    }
  }, [value]);
  var handleInputAccept = function handleInputAccept(eventValue, inputMask) {
    setInputValue(eventValue);
    var nextValue = inputMask.typedValue;
    setValue(nextValue);
    if (toStringValue(nextValue) !== toStringValue(value)) {
      invoke(onChange, nextValue);
    }
  };
  var handleBlur = function handleBlur(e) {
    var finalInputValue = toStringValue(value);
    if (inputValue !== finalInputValue) {
      setInputValue(finalInputValue);
    }
    invoke(props.onBlur, e);
  };
  return /*#__PURE__*/_jsx(IMaskInput, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    as: as,
    type: "tel",
    value: inputValue,
    options: IMASK_DATE_INPUT_OPTIONS,
    onAccept: handleInputAccept,
    onBlur: handleBlur,
    spellCheck: false
  }));
});
var INPUT_FORMAT = 'dd.MM.yyyy';
function toStringValue(value) {
  if (value instanceof Date) {
    return format(INPUT_FORMAT, value);
  }
  return '';
}